<!-- START Sidebar -->
<div class="aside-inner">
  <nav
    class="sidebar"
    sidebar-anyclick-close=""
    [class.show-scrollbar]="settings.getLayoutSetting('asideScrollbar')"
    role="navigation"
    aria-label="Main Navigation"
  >
    <h2 class="sr-only">Main Navigation</h2>
    <!-- Sidebar navigation -->
    <ul class="sidebar-nav" role="tree" aria-label="Sidebar Navigation">
      <!-- User Section -->
      <li class="has-user-block" role="treeitem">
        <h3 class="sr-only">User Information</h3>
        <app-userblock></app-userblock>
      </li>

      <!-- Menu Items -->
      <li
        *ngFor="let item of menuItems"
        [ngClass]="{ 'nav-heading': item.heading }"
        [routerLinkActive]="['active']"
        role="treeitem"
        [attr.aria-expanded]="item.submenu ? 'false' : null"
      >
        <!-- Menu Heading -->
        <h3 *ngIf="item.heading" class="menu-heading">
          {{ item.text }}
        </h3>

        <!-- External Links -->
        <a
          *ngIf="!item.heading && !item.submenu && item.elink"
          [attr.target]="item.target"
          [attr.href]="item.elink"
          class="sidebar-link"
          role="link"
          [attr.aria-label]="'External link to ' + item.text"
        >
          <span *ngIf="item.alert" class="badge">{{ item.alert }}</span>
          <em *ngIf="item.icon" class="{{ item.icon }}" aria-hidden="true"></em>
          <span class="menu-text">{{ item.text }}</span>
        </a>

        <!-- Single Menu Item -->
        <a
          *ngIf="!item.heading && !item.submenu && !item.elink"
          [routerLink]="item.link"
          class="sidebar-link"
          role="link"
          [attr.aria-label]="'Navigate to ' + item.text"
        >
          <span *ngIf="item.alert" class="badge">{{ item.alert }}</span>
          <em *ngIf="item.icon" class="{{ item.icon }}" aria-hidden="true"></em>
          <span class="menu-text">{{ item.text }}</span>
        </a>

        <!-- Submenu -->
        <a
          *ngIf="!item.heading && item.submenu"
          aria-haspopup="true"
          aria-expanded="false"
          class="sidebar-link submenu-toggle"
          role="button"
          tabindex="0"
          (click)="toggleSubmenuClick($event)"
          (keydown.enter)="toggleSubmenuClick($event)"
          (keydown.space)="toggleSubmenuClick($event)"
          [attr.aria-label]="'Expand submenu for ' + item.text"
        >
          <span *ngIf="item.alert" class="badge">{{ item.alert }}</span>
          <em *ngIf="item.icon" class="{{ item.icon }}" aria-hidden="true"></em>
          <span class="menu-text">{{ item.text }}</span>
        </a>
        
        <!-- Sidebar Subnav -->
        <ul
          *ngIf="item.submenu"
          class="sidebar-subnav"
          aria-label="'Submenu for ' + item.text"
          role="group"
        >
          <li *ngFor="let subitem of item.submenu" role="treeitem">
            <a
              *ngIf="!subitem.heading && !subitem.submenu && subitem.elink"
              [attr.target]="subitem.target"
              [attr.href]="subitem.elink"
              class="sidebar-link"
              [attr.aria-label]="'External link to ' + subitem.text"
            >
              <em *ngIf="subitem.icon" class="{{ subitem.icon }}" aria-hidden="true"></em>
              <span class="menu-text">{{ subitem.text }}</span>
            </a>
          </li>
        </ul>
      </li>

      <!-- Mobile Actions (Change Issuing Agency) -->
      <li class="nav-item d-block d-md-none">
        <a
          *ngIf="issuingEntity && user.issuingEntites.length > 1 && user.isInRole('AgencyUser')"
          (click)="changeIssuingEntity()"
          role="button"
          tabindex="0"
          aria-label="'Change Issuing Agency to ' + issuingEntity.name"
        >
          <em class="bi bi-arrow-left-right" aria-hidden="true"></em>
          {{ issuingEntity.name }}
        </a>
      </li>

      <!-- Mobile Actions (User Profile) -->
      <li class="nav-item d-block d-md-none">
        <a [routerLink]="'/users/profile'" aria-label="Go to user profile" role="link" tabindex="0">
          <em class="bi bi-person" aria-hidden="true"></em>
          Profile
        </a>
      </li>
    </ul>

    <!-- Application Version -->
    <div class="version" role="contentinfo" aria-label="Application Version">
      <span>{{ version }}</span>
    </div>
  </nav>
</div>
<!-- END Sidebar -->

<!-- Modal Template -->
<ng-template #selectIssuingEntity let-c="close" let-d="dismiss">
  <div class="modal-header" role="dialog" aria-labelledby="modal-basic-title" aria-modal="true">
    <h2 class="modal-title" id="modal-basic-title">Select Agency</h2>
    <button type="button" class="close" aria-label="Close dialog">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <app-select-issuing-entity (refresh)="onRefresh($event)" aria-labelledby="modal-basic-title">
    </app-select-issuing-entity>
  </div>
</ng-template>